import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDPZDTFJj85pL685E9zptT6xAGsh4i-hIs",
    authDomain: "vue-project-420.firebaseapp.com",
    databaseURL: "https://vue-project-420.firebaseio.com",
    projectId: "vue-project-420",
    storageBucket: "vue-project-420.appspot.com",
    messagingSenderId: "763793684458",
    appId: "1:763793684458:web:30767c5cae1119b1ca6493",
    measurementId: "G-W68HBPM4Y7"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  export const db = firebaseApp.firestore();


  